'use strict'
angular.module('TurneroApp').component('coTramiteAlternativa', {
    bindings: {
        usuario: '<'
    },
    controller: ['$state', '$rootScope', 'utilsService', '$window', 'miDoctaModoService', function ($state, $rootScope, utilsService, $window, miDoctaModoService) {
        var ctrl = this;
        $rootScope.btnConoceCentro = false;
        ctrl.layoutState = $state.$current.name.split('.')[0];
        ctrl.urlHome = ctrl.layoutState === 'ciudadanoPortal' ? 'turnosPortal' : 'turnos';

        ctrl.limpiarMemoria = function () {
            $rootScope.$broadcast('esHome', false);
            $rootScope.$broadcast('esCalendario', false);
            $rootScope.$broadcast('esTasaRetributiva', false);
        };

        ctrl.$onInit = function () {
            if (!utilsService.matchRuleShort($state.current.url, $rootScope.urlHostServer, "turnosPortal?*")) {
                ctrl.limpiarMemoria();
            }
        };

        ctrl.regresar = function ($event) {
            $rootScope.$broadcast('esHome', true);
            $rootScope.$broadcast('esCalendario', false);
            $rootScope.$broadcast('esTasaRetributiva', false);
            $rootScope.btnConoceCentro = false;
            $rootScope.Id_Centro_Atencion = null;
            if (miDoctaModoService.estaActivo()) {
                if ($event) {
                    $event.preventDefault();
                }
                $window.location.href = miDoctaModoService.urlInternaConModo('/turnos');
            }
        };

        ctrl.GoToCentro = function () {
            $rootScope.btnConoceCentro = true;
            var tramite = {
                Id_Tramite: null,//1216
                Id_Tramite_Relevado: null,//1216
                Id_Tramite_Aplicacion: null,
                N_Tramite: "",
                N_Unidad_Tramite: "",
                Telefono: null,
                Url: ""
            };
            $rootScope.$broadcast('seleccionarTramite', tramite);
            $state.go('ciudadano.centrosatencion');
        };

        ctrl.GoToTramites = function () {
            $rootScope.btnConoceCentro = false;
            $state.go('ciudadano.tramites');
        };
    }],
    template: require('./turnoOnlineTramiteAlternativa.html')
});



// WEBPACK FOOTER //
// ./app/components/turnos/turnosOnline/turnoOnlineTramiteAlternativaComponente.js